

export const OUR_SERVICES_SLIDE_PATH_KEY = 'slideName'
export const FAQ_CATEGORY_KEY = 'faq_category'
export const FAQ_DESCRIPTION_KEY = "faq_description_key"
export const PROCESS_DOCUMENTS_PAGES_PATH_KEY = "process_documents_pages_pages_key"
export const ONBOARDING_ID_KEY = "onboarding_id_key"
export const ONBOARDING_STEP_KEY = "onboardingStep"
export const CASE_STUDY_CATEGORY_KEY = "case_study_category_key"
export const CASE_STUDY_SLUG_KEY = "case_study_slug_key"
export const CASE_STUDY_INDUSTRY_KEY = "caseStudyIndustry_key"
export const ABOUT_US_KEY = "about_us_key"
export const QUALITY_CHECK_KEY = "quality_check_key"
export const PRICING_MATRIX_TYPE_KEY = "pricingMatrixKey"
export const PRICING_MATRIX_SUBTYPE_KEY = "pricingMatrixSubTypeKey"
export const OUR_CAPABILITIES_KEY = "ourCapabilitiesKey"
export const OUR_CAPABILITIES_SECTION_KEY = "ourCapabilitiesSectionKey"
export const OUR_CAPABILITIES_USER_KEY = "ourCapabilitiesUserKey"
export const HARD_TO_REACH_KEY = "hardToReachKey"
export const TAAS_ACCESS_ID = "tass_access_id"
export const V2_OUR_CAPABILITIES_KEY = "ourCapabilitySlideKey"
export const V2_OUR_CAPABILITIES_INTERNAL_SLUG = "ourCapabilitiesSectionKey"
export const V2_USER_KEY = "v2UserKey"
export const V2_TAAS_INTERNAL_SLUG = "v2TaasInternalSlug"

// React router v6 works differently and hence care should be maintained while defining routes
// A route starting with '/' is an absolute path ===> It will replace from the root of the url
// Without the slash it will append to the current URL in the address bar

const ROUTES_OBJ = {
  VIDEO: "/video",
  PHYSICIAN_VIDEO: "/physiciandatabase-mock",
  LOGIN: "/login",
  ADMIN_LOGIN: "/admin_login",
  ADD_CLIENT: "/add_client",
  SEPERATE_OUR_CAPABILITIES_PROGRAMMING: "programming_capabilities",
  SEPERATE_OUR_CAPABILITIES_SCREENSHARE: "screenshare_methodology",
  SEPERATE_OUR_CAPABILITIES_VISUALIZATION: "visualization_capabilities",
  HOME: "/",
  ABOUT_US: "/about_us",
  CRP_OAUTH_LOGIN: "/auth/login",

  // Pitch Deck
  PITCH_DECK: {
    ROOT: "/pitch_deck",
    V2: "/v2",
    DETAILS: "details",
    VIEW_DETAILS: 'view_details',
    MOBILE: "mob"
  },



  // Collaboration Proposition
  COLLABORATION_PROPOSITION: {
    ROOT: "/collaboration_proposition",
    DETAILS: "details"
  },

  // Proposal template routes
  PROPOSAL_TEMPLATE: "/proposal",
  DETAIL_PROPOSAL: "detail_proposal",
  PROPOSAL_TEMPLATE_PREVIEW: `/proposal/preview`,
  PROPOSAL_TEMPLATE_END_CLIENT: "/proposal/detail_proposal",
  PROPOSAL_TEMPLATE_END_CLIENT_DETAILS: `proposal_details`,
  PROPOSAL_TEMPLATE_END_CLIENT_VIEW_DETAILS: `view_details`,
  TAAS: {
    TAAS_ROOT: '/taas',
    TAAS_ACCESS_ID: `:${TAAS_ACCESS_ID}`,
    TAAS_COST_ESTIMATE: `cost_estimate`,
    TAAS_COST_ESTIMATE_VIEW: `cost_estimate/view`,
    TAAS_ARRANGE_A_CALL: `arrange_a_call`,
    TAAS_AWARD: "award",
    TAAS_THANK_YOU: "thank_you",

  },


  /**
 * About Us Routes
 */
  UNIQUE_KEY_FOR_TAAS_ONLY: '/t/our_capabilities',
  OUR_CAPABILITIES: {
    OUR_CAPABILITIES_LABEL: `/our_capabilities`,
    ROOT: `/our_capabilities/:${OUR_CAPABILITIES_KEY}`,
    SLUG: `:${OUR_CAPABILITIES_SECTION_KEY}`,
    OUR_CAPABILITIES_USER_KEY: `:${OUR_CAPABILITIES_USER_KEY}`,
    HARD_TO_REACH: "hard_to_reach",
    COMPREHENSIVE_RESEARCH: "comprehensive_research",
    BEST_IN_CLASS: "best_in_class",
    TAAS: "taas",
    getOurCapabilitiesSlidePath(slideName = this.HARD_TO_REACH, userId) {
      if (userId) return this.ROOT.replace(`:${OUR_CAPABILITIES_KEY}`, `${slideName}/${userId}`)
      return this.ROOT.replace(`:${OUR_CAPABILITIES_KEY}`, slideName)
    },
  },
  ABOUT_US_CATEGORY: {
    ROOT: `/about_us/:${ABOUT_US_KEY}`,
    OUR_JOURNEY: 'our_journey',
    INDUSTRY_EXPERTISE: 'industry_expertise',
    ASSOCIATION_MEMBERSHIP: 'association_membership',
  },
  FAQ: "/faq",
  FAQ_CATEGORY: `:${FAQ_CATEGORY_KEY}`,
  FAQ_DESCRIPTION_PAGE: `:${FAQ_DESCRIPTION_KEY}`,
  OUR_SERVICES: {
    ROOT: `/our_services/:${OUR_SERVICES_SLIDE_PATH_KEY}`,
    SLIDE_NAME_HARD_TO_REACH: "hard_to_reach",
    AUDIENCE_PROFILE: "audience_profiling",
    STUDIES_WE_CONDUCT: "studies_we_conduct",
    SLIDE_NAME_QUALITY_CHECK: "quality_check",
    SLIDE_NAME_COMPREHENSIVE_RESEARCH: "comprehensive",
    COMPREHENSIVE_RESEARCH_SURVEY_PROGRAMMING: "survey_programming",
    COMPREHENSIVE_RESEARCH_DASHBOARDING: "dashboarding",
    COMPREHENSIVE_RESEARCH_FIELDWORK: "fieldwork",
    CATI_QUALITY_CHECKS: 'cati_quality_checks',
    CAWI_QUALITY_CHECKS: 'cawi_quality_checks',
    DATABASE_MANAGEMENT: 'database_management',
    getOurServicesSlidePath(slideName = this.SLIDE_NAME_HARD_TO_REACH) {
      return this.ROOT.replace(`:${OUR_SERVICES_SLIDE_PATH_KEY}`, slideName)
    },
  },
  QUALITY_CHECK_CATEGORY: {
    ROOT: `/our_services/quality_check/:${QUALITY_CHECK_KEY}`,
  },
  PROCESS_DOCUMENTS: "/process_documents",
  PROCESS_DOCUMENTS_PAGES: `:${PROCESS_DOCUMENTS_PAGES_PATH_KEY}`,


  CASE_STUDY: {
    ROOT: "/case_studies",
    CASE_STUDY_CATEGORY: `:${CASE_STUDY_CATEGORY_KEY}`,
    CASE_STUDY_PAGES: `:${CASE_STUDY_SLUG_KEY}`,
    CONSUMER: "consumer",
    GOVERNMENT: "government",
    C_SUITE: "c_suite",
    FINANCE: "finance",
    HEALTHCARE: "healthcare",
    IT: "it_case_study"
  },

  PRICING_MATRIX: {
    ROOT: "/pricing_matrix",
    PRICING_MATRIX_STEP: {
      PRICING_STEP: `:${PRICING_MATRIX_TYPE_KEY}/:${PRICING_MATRIX_SUBTYPE_KEY}`,
      //types in pricing matrix
      BUSINESS_PROFESSIONALS: `business_professionals`,
      CONSUMER_AUDIENCE: `consumer_audience`,
      GOVERNMENT_EMPLOYEES: `government_employees`,
      HEALTHCARE_AUDIENCE: `healthcare_audience`,
      HIGH_NET_WORTH_INDIVIDUAL: `high_net_worth_individual`,
      //sub types of pricing matrix
      AUDIENCE: "audience",
      GEOGRAPHIES: "geographies",
      TITLES: "titles",
      TARGETABLE_SCREENERS: "targetable_screeners",
      IRLEVEL: "ir_level",
      LOI: "loi",
      PRICE_CHART: "price_chart",
      PRICING_ESTIMATE: "pricing_estimate",
    },



  },

  POLICY_DOCUMENTS: {
    PUBLIC_ROOT: `/policyDocuments`,
    PUBLIC_ROOT_V2: `/policyDocuments2`,
    ROOT: `/policy_documents`,
    CODE_OF_MARKET_RESEARCH: "code_of_market_research",
    GDPR_COMPLIANCE_PROTOCOL: "gdpr_compliance_protocol",
    PRIVACY_PRATICE: "privacy_practice",
    DATA_PRIVACY_HANDBOOK: "data_privacy_handbook",
    ESOMAR_36_QUESTIONS: "esomar_36_questions"
  },
  ONBOARDING_CLIENT: {
    UNIQUE_FROM_CRP: '/onboarding',
    ROOT: `/onboarding/:${ONBOARDING_ID_KEY}/:${ONBOARDING_STEP_KEY}`,
    ONBOARDING_ID_KEY: `:${ONBOARDING_ID_KEY}`,
    ONBOARDING_STEP_KEY: `:${ONBOARDING_STEP_KEY}`,
    CLIENT: "client",
    NDA: "nda",
    ONBOARDING_WITHOUT_FORMS: "owf",
    ONBOARDING_CLIENT_INFO: "clientInfo",
    SLA_MSA: "sla_msa",
    ONBOARDING_SUCCESS: 'success',
    getStepPath(id = this.ONBOARDING_ID_KEY, step = this.CLIENT) {
      return this.ROOT.replace(`:${ONBOARDING_ID_KEY}/:${ONBOARDING_STEP_KEY}`, `${id}/${step}`)
    }
  },


  RFQ: {
    ROOT: '/rfq/market_research',
    BRIEF: 'brief',
    THANK_YOU: "thank_you",
    APPROXIMATE_COST: 'approximate_cost',
    EMAIL_SUMMARY: 'email_summary',
    AWARD: 'award',
    SCHEDULE_MEETING: "schedule_meeting",
    WOHOO: "awarded"
  },
  END_CLIENT_RFQ: {
    ROOT: '/rfq/end_client',
    SCHEDULE_MEETING: "schedule_meeting",
    BRIEF: "brief",
    THANK_YOU: "thank_you"
  },


  CIP_V2: {
    ROOT: "/v2",
    TAAS: {
      ROOT: 'taas',
      TAAS_COST_ESTIMATE: `cost_estimate`,
      V2_USER_KEY: `:${V2_USER_KEY}`,
      TAAS_INTERNAL_SLUG: `:${V2_TAAS_INTERNAL_SLUG}`,
      TEAM_AS_A_SERVICE_OVERVIEW: "team_as_a_service_overview",
      ORGANIZATION_CHART: "organization_chart",
      BUSINESS_CONTINUITY_PLAN: "business_continuity_plan",
      DATA_SECURITY: "data_security",
      USE_CASES: "use_cases"
    },
    OUR_CAPABILITIES: {
      ROOT: `our_capabilities/:${V2_OUR_CAPABILITIES_KEY}`,
      PRIMARY_QUANTITATIVE_RESEARCH: "primary_quantitative_research",
      PRIMARY_QUALITATIVE_RESEARCH: "primary_qualitative_research",
      MARKET_COMPETITIVE_INTELLIGENCE: "market_competitive_intelligence",
      getOurCapabilitiesSlidePath(slideName = this.PRIMARY_QUANTITATIVE_RESEARCH) {
        return `/v2/${this.ROOT.replace(`:${V2_OUR_CAPABILITIES_KEY}`, slideName)}`
      },
      INTERNAL_SLUG: `:${V2_OUR_CAPABILITIES_INTERNAL_SLUG}`,
      //for PRIMARY_QUANTITATIVE_RESEARCH
      SURVEY_PROGRAMMING: "survey_programming",
      ACCESS_HARD_TO_REACH: "access_to_hard-to-reach_audiences",
      SURVEY_METHODOLOGY: "survey_methodology",
      REPORT_AND_VISUALIZATION: "reporting_&_visualization",
      OTHER_SUPPORT_SERVICES: "other_support_services",

      //for PRIMARY_QUALITATIVE_RESEARCH
      RESEARCH_OVERVIEW: "research_overview",
      EXPERT_PROFILING: "expert_profiling",

      //for MARKET_COMPETITIVE_INTELLIGENCE
      SINGLE_PAGE: "intelligence"

    }
  }

}

export { ROUTES_OBJ as ROUTES }
